import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}><path fillRule="evenodd" d="M8.403 35A1.403 1.403 0 017 33.597V12.08a1.403 1.403 0 112.806 0v21.516c0 .775-.628 1.403-1.403 1.403z" clipRule="evenodd" opacity=".5" /><path d="M19 9h17l-3.81 6.5L36 22H19z" opacity=".5" /><path d="M7 6h17v13H7z" /></svg>;